import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import darkTheme from '../../src/theme';
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { RWebShare } from "react-web-share";
import ShareIcon from '../../public/images/icons/Share.png'
import Image from "next/image";

const dealTitleCardNew = {
  '& h1': {
    fontSize: 26,
    color: darkTheme.palette.primary.title,
    fontWeight: 500,
    textTransform: 'capitalize !important',
    marginBottom: darkTheme.spacing(0.5),    
  },
  '& h5': {
        fontSize: 14,
        textTransform: 'capitalize',    
        color: darkTheme.palette.primary.dates,       
        fontWeight: 400,    
    },
    '& h6': {
        fontSize: 16,
        color: darkTheme.palette.primary.location,
        fontWeight: 400,    
    },  
};

const button = {
  minWidth: 40,
  width: 40,
  height: 40,
  borderRadius: 50,
  zIndex:9,
  padding: 0,  
  position: 'fixed',
  top: 75,
  right: 50,    
  [darkTheme.breakpoints.down("md")]: {
    position: 'absolute',
    top: 'auto',
    marginTop: '-80px',
    right: 35, 
  }
};

function Title({ data, url }) {  
  const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

  return (
    <>            
        <Typography component="div" sx={dealTitleCardNew}>
        <Stack display="flex" justifyContent="space-between" flexDirection="row">
          <Typography component="div">
            <Typography variant="h1">{data.title.toLowerCase()}</Typography>
            <Typography variant="h6">Valid for {data.entry_free_upto}&nbsp; Person<small>(s)</small></Typography>
          </Typography>
            <Stack
                sx={{
                    display: "flex",
                    flexDirection: "row",                    
                    justifyContent: "flex-end",                   
                    zIndex: 999
                }}                
            >
                <RWebShare
                data={{
                    text: data.title,
                    url: url,
                    title: data.title,
                }}
                >
                <Button
                    sx={button}
                    type="button"                                                           
                    id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                    aria-expanded={openMenu ? "true" : undefined}
                    onClick={handleClick}                    
                >                          
                    <Image src={ShareIcon} width={40} height={40} alt='shareIcon' />
                </Button>
                </RWebShare>
            </Stack>
          </Stack>
        </Typography>      
    </>
  );
}

export default Title;
